import { Initialize } from './Initialize';
import { Helper } from './Helper';
import { Form } from './Form';


/**
 * Polyfill
 */

// forEach
if (! NodeList.prototype.forEach) {
  NodeList.prototype.forEach = (Array.prototype as any).forEach;
}

// object-fit
((): void => {
  const objectFitImages: any = require('object-fit-images');
  objectFitImages();
})();


/**
 * プラグイン
 */

// Slick
((): void => {
  require('slick-carousel');
  const slickObj: any = $('[data-slick]');
  slickObj.slick({
    autoplaySpeed: 4000,
    speed: 500,
    // adaptiveHeight: true,
    arrows: false,
    autoplay: true
  });
})();

// fancybox
((): void => {
  require('@fancyapps/fancybox');
  const fancyObj: any = $('[data-fancybox]');
  fancyObj.fancybox({
    buttons: [
      "close"
    ],
    infobar: false,
    autoPlay: false,
    animationDuration: 500,
    transitionDuration: 500
  });
})();


/**
 * 実行クラス
 */
new (class App
{
  /**
   * コンストラクタ
   */
  constructor() {

    // HTML要素にクラス名を追加 (先頭に記述)
    new Initialize();

    const helper = new Helper;

    // inview
    helper.inview('[data-js="inview"]');

    // ヘッダー
    helper.header();

    // ページトップボタン
    helper.smoothScroll('[data-js="pageTopButton"]');
    helper.scrollFade('[data-js="pageTopButton"]');

    // WYSIWYG
    helper.wrap('.box-wpContent table.wp-block-table, .box-wpContent > table', 'div' ,'wp-block-table-wrapper');
    helper.wrap('.box-wpContent p > iframe', 'div', 'wp-iframe-wrapper');

    // 動画のポップアップ
    helper.movie('.fn-movieButton', '.fn-movie', '<iframe width="560" height="315" src="https://www.youtube.com/embed/1P4NS0B7Bp8?autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
    helper.movie('.fn-movieButton-01', '.fn-movie-01', '<iframe width="560" height="315" src="https://www.youtube.com/embed/Hdi_aUL4Ft0?autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
    helper.movie('.fn-movieButton-02', '.fn-movie-02', '<iframe width="560" height="315" src="https://www.youtube.com/embed/nMr7383D4is?autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
    helper.movie('.fn-movieButton-03', '.fn-movie-03', '<iframe width="560" height="315" src="https://www.youtube.com/embed/aOMgMHlyB_k?autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');

    // お問い合わせフォーム
    new Form('[data-js="formValidate"]');
  }
});
